import { UserType } from './dossier-state';

export interface DossierComments {
  userName: string;
  userType?: UserType;
  comment: string;
  timestamp: string;
  commentType: DossierCommentsType;
  isPinned?: boolean;
}

export type DossierCommentsType = `${DossierCommentsEnum}`;

export enum DossierCommentsEnum {
  fitter = 'fitter',
  abandon = 'abandon',
  sinister = 'sinister',
  appointment = 'appointment',
  insurer = 'insurer',
  finishLater = 'finishLater',
  other = 'other',
  noShow = 'noShow',
}
